var EqMateriovigilance = {
  VALID: 0,
  INFOS: 2,
  ALERT: 3,
  REMINDER: 1,
};

module.exports = EqMateriovigilance;
